import {EnumValidValueItemModel} from './enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';

export class EnumValidValueModel extends XauditModel {
  static EMPTY_ENUM = '00000000-0000-0000-0000-000000000000';

  ValidValueId: string;
  ValidValueName: string;
  TDOCID: number;
  isSystem: boolean;
  enumValidValueItems: EnumValidValueItemModel[];
}
